import { notCss } from './util'

export const quirks = notCss({})
